import * as React from 'react';

import { buildDegreeCategoryUrlRelative, buildDegreeUrlRelative } from 'bundles/common/utils/urlUtils';
import type { BreadcrumbsProps } from 'bundles/xddp/types';

const XDDPBreadcrumbs = ({
  slug,
  programName,
  programCategory,
  programCategoryId,
  currentNavElement,
}: BreadcrumbsProps) => {
  if (!currentNavElement) {
    return null;
  }

  return (
    <div className="rc-XDDPBreadcrumbs" role="navigation" aria-label="Breadcrumb">
      <ol className="breadcrumbs">
        <li>
          <a href="/degrees">Online Degrees</a>
          <span className="separator" aria-hidden="true">
            &gt;
          </span>
        </li>

        <li>
          <a href={buildDegreeCategoryUrlRelative(programCategoryId)}>{programCategory}</a>
          <span className="separator" aria-hidden="true">
            &gt;
          </span>
        </li>

        <li>
          <a href={buildDegreeUrlRelative(slug)}>{programName}</a>
          <span className="separator" aria-hidden="true">
            &gt;
          </span>
        </li>

        <li aria-current="page">{currentNavElement.label}</li>
      </ol>
    </div>
  );
};

export default XDDPBreadcrumbs;
